module.exports = __webpack_public_path__ + "media/images/sample/ic_apple@2x-4e4421a38b8a866a0a66240500f05732.png";